import { logger } from '@adornis/base/logging.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { mongo } from '../server/mongo.js';

export type NotificationSendLogChannel = 'whatsapp' | 'email-fallback' | 'email';
export type NotificationSendLogStatus = 'sent' | 'failed' | 'dropped';

@Entity()
export class NotificationSendLog extends MongoEntity {
  static override _class = 'NotificationSendLog';
  static override _collectionName = 'notification-send-logs';

  @Field(type => String)
  channel!: NotificationSendLogChannel;

  @Field(type => String)
  institutionID!: string;

  @Field(type => String)
  userID!: string;

  @Field(type => String)
  mailTemplateType!: string;

  @Field(type => String)
  status!: NotificationSendLogStatus;

  @Field(type => String)
  errorMessage: Maybe<string>;

  @Field(type => String)
  waMessageID: Maybe<string>;

  @Field(type => Date)
  timestamp!: Date;
}

export async function ensureNotificationSendLogIndexes(): Promise<void> {
  try {
    const collection = mongo().collection(NotificationSendLog._collectionName);
    await collection.createIndex({ institutionID: 1, channel: 1, status: 1, timestamp: -1 });
  } catch (err) {
    logger.error({ err }, 'failed to create notification send log index');
  }
}
